import { connect } from 'react-redux';
import App from './App';

const mapStateToProps = (state) => {
  return {
    currentUser: state.user.currentUser
  };
};

export default connect(mapStateToProps)(App);